import React from 'react'
import PropTypes from 'prop-types'
import OpalTile from '../../../../opal/OpalTile'
import AdminPage from '../../../admin/shared/AdminPage'
import FlexRow from '../../../../molecules/FlexRow'
import PolicyLink from '../../../../atoms/PolicyLink'
import PolicyNotAvailable from '../../../../atoms/PolicyNotAvailable'

function DenaliAIIndexView ({ root }) {
  return (
    <AdminPage>
      <FlexRow className='items-center justify-center' style={{ flexWrap: 'wrap' }}>
        <PolicyLink to={`${root}/ai/configuration`} policy='admin_denali_internal'>
          <OpalTile size='xl' className='opal-selectable font-size-lg text-center p-sm'>
            Denali AI Configuration
          </OpalTile>
        </PolicyLink>
        <PolicyLink to={`${root}/ai/skills`} policy='admin_denali_internal'>
          <OpalTile size='xl' className='opal-selectable font-size-lg text-center p-sm'>
            Denali AI Skills
          </OpalTile>
        </PolicyLink>
        <PolicyLink to={`${root}/ai/evals`} policy='admin_denali_internal'>
          <OpalTile size='xl' className='opal-selectable font-size-lg text-center p-sm'>
            Denali AI Evals
          </OpalTile>
        </PolicyLink>
        <PolicyLink to={`${root}/ai/meetings`} policy='admin_denali_internal'>
          <OpalTile size='xl' className='opal-selectable font-size-lg text-center p-sm'>
            Denali AI Meetings
          </OpalTile>
        </PolicyLink>
        <PolicyNotAvailable policies={['admin_denali_internal']} />
      </FlexRow>
    </AdminPage>
  )
}

DenaliAIIndexView.propTypes = {
  root: PropTypes.any
}

export default DenaliAIIndexView
